function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 3h10a.5.5 0 01.5.5v9a.5.5 0 01-.5.5h-.5V7.5a2 2 0 00-2-2h-5a2 2 0 00-2 2V13H3a.5.5 0 01-.5-.5v-9A.5.5 0 013 3zm2 10h6v-.804H5V13zm0-2.304v-.972h6v.972H5zm0-2.472h6V7.5a.5.5 0 00-.5-.5h-5a.5.5 0 00-.5.5v.724zM3.5 14.5H3a2 2 0 01-2-2v-9a2 2 0 012-2h10a2 2 0 012 2v9a2 2 0 01-2 2H3.5z",
  fill: "currentColor"
});

function SvgIconBranch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgIconBranch;